import { css } from 'lit';
export const colors = css `
    :host {
        /* MAIN */
        --body: #f7f7f7;
        --theme-primary: var(--sdb-theme-primary, #00b1aa);
        --theme-primary-text: var(--sdb-theme-primary-text, #ffffff);
        --theme-secondary: var(--sdb-theme-secondary, #1e958c);
        --theme-tertiary: var(--sdb-theme-tertiary, #1f9bb4);
        /* PROGRESS BAR */
        --progress-primary: var(--sdb-progress-primary, #f49d10);
        --progress-secondary: var(--sdb-progress-secondary, #033850);
        --progress-tertiary: var(--sdb-progress-tertiary, #cc6666);
        --progress-100: var(--sdb-progress-100, #00b1aa);
        /* ELEMENT COLORS */
        --element-lightgrey: #eaeaea;
        --element-grey: #dddedf;
        --element-darkgrey: #cacaca;
        --element-disabled: #a0a0a0;
        /* TEXT */
        --text-primary: #023850;
        --text-light: #ffffff;
        --text-dark: #023850;
        --font-family: Source Sans Pro, sans-serif;
        --font-default: 400 16px Source Sans Pro, sans-serif;
        /* DIALOG */
        --warning-color: var(--sdb-warning-color, #face88);
        --warning-background: var(
            --sdb-warning-background,
            rgba(244, 157, 16, 0.07)
        );
        --alert-color: var(--sdb-alert-color, #fa8b88);
        --alert-background: var(
            --sdb-alert-background,
            rgba(244, 23, 16, 0.07)
        );
        --success-color: var(--sdb-success-color, #80d8d5);
        --success-background: var(
            --sdb-success-background,
            rgba(0, 177, 170, 0.07)
        );
        --inprogress-color: var(--sdb-inprogress-color, #2196f3);
        --inprogress-background: var(
            --sdb-inprogress-background,
            rgba(33, 150, 243, 0.07)
        );
        /* BUTTONS */
        --btn-primary: var(--sdb-button-primary, #f49d10);
        --btn-primary-hover: var(--sdb-button-primary-hover, #ed7422);
        --btn-primary-text: var(--sdb-button-primary-text, #ffffff);
        --btn-secondary: var(--sdb-button-secondary, #023850);
        --btn-secondary-hover: var(--sdb-button-secondary, #013247);
        --btn-secondary-text: var(--sdb-button-secondary-text, #ffffff);
        --btn-disabled: #eee;
        /* CHIPS */
        --chip-warning-background-color: var(
            --sdb-chip-warning-background-color,
            #f49d10
        );
        /* */
        --separator-color: var(--element-lightgrey);
    }
`;
//# sourceMappingURL=sdb-colors.js.map